import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { stationsSelect } from 'Services/api/stantionsApi';
import { reportsSelect } from 'Services/api/reportsApi';
import React from "react";

// TODO: удалить все фильтры отсюда (!delete)

const STATIONS_FILTER1 = 'STATIONS_FILTER1';
const STATIONS_FILTER2 = 'STATIONS_FILTER2';
const STATIONS_FILTER3 = 'STATIONS_FILTER3';
const STATIONS_FILTER4 = 'STATIONS_FILTER4';
const STATIONS_FILTER5 = 'STATIONS_FILTER5';
const REPORTS_FILTER1 = 'REPORTS_FILTER1';

export const defaultStationsFilter = {
  searchInput: '',
  fgbu: null,
  cgms: null,
  category: null,
  type: null,
  showDatasourceType: 0,
  showDatasourceMode: 0,
  showDatasourceReleases: 0,
  showDatasourceEnabled: 0,
  showDatasourceDanger: 0,
  showDatasourceStatus: 0,
  showStatusFilter: '0',
  datasourceTypesFilter: [],
};

const defaultReportsFilter = {
  searchInput: '',
};

// stations filters
// Здесь payload это одно или несколько полей из defaultStationsFilter
const createSetStationsFilter = (filterName) => createAsyncThunk('stationsSetFilter1', (payload) => ({
  filterType: 'stations',
  filterName,
  payload,
}));

export const stationsSetFilter1 = createSetStationsFilter(STATIONS_FILTER1);
export const stationsSetFilter2 = createSetStationsFilter(STATIONS_FILTER2);
export const stationsSetFilter3 = createSetStationsFilter(STATIONS_FILTER3);
export const stationsSetFilter4 = createSetStationsFilter(STATIONS_FILTER4);
export const stationsSetFilter5 = createSetStationsFilter(STATIONS_FILTER5);

// reports filters
export const reportsSetFilter1 = createAsyncThunk('reportsSetFilter1', (payload) => ({
  filterType: 'reports',
  filterName: REPORTS_FILTER1,
  payload,
}));

/**
 *
      Инжектится в PrivateRouter.js - store.injectReducer(APP_SLICE, appSlice.reducer);
 *
 */
function stationsSetFilter(state, action) {
  const { filterType, filterName, payload } = action.payload;
  Object.assign(state[filterType][filterName], { ...payload });
}

function getTimeZones() {
  const localTimezones = window.localStorage.getItem('timezones');
  return localTimezones ? JSON.parse(localTimezones) : {
    selectedUserTimeZone: '+00:00',

    stations: '+00:00',
    selectedStations: 'UTC',
  };
}

export const APP_SLICE = 'app';
const appSlice = createSlice({
  name: APP_SLICE,
  initialState: {
    // todo: переименовать в sidebar
    home: {
      showSidebar: true,
      reportSidebar: true,
    },
    stations: {
      [STATIONS_FILTER1]: { ...defaultStationsFilter },
      [STATIONS_FILTER2]: { ...defaultStationsFilter },
      [STATIONS_FILTER3]: { ...defaultStationsFilter },
      [STATIONS_FILTER4]: { ...defaultStationsFilter },
      [STATIONS_FILTER5]: { ...defaultStationsFilter }
    },
    reports: {
      [REPORTS_FILTER1]: { ...defaultReportsFilter },
    },
    timezones: getTimeZones(),
    // timezones: '+3',

  },
  reducers: {
    // здесь state только для этого слайса
    appHomeToggleShowSidebar: (state, action) => {
      // приходит объект, например { reportSidebar: true };
      const [name] = Object.keys(action.payload);
      Object.assign(state.home, { [name]: !action.payload[name] });
    },
    setTimeZone: (state, action) => {
      Object.assign(state, { timezones: { ...state.timezones, [action.payload.name]: action.payload.value } });
      window.localStorage.setItem('timezones', JSON.stringify(state.timezones));
    },
  },
  extraReducers: {
    [stationsSetFilter1.fulfilled]: stationsSetFilter,
    [stationsSetFilter2.fulfilled]: stationsSetFilter,
    [reportsSetFilter1.fulfilled]: (state, action) => {
      const { filterType, filterName, payload } = action.payload;
      Object.assign(state[filterType][filterName], { ...payload });
    },
  },
});

export default appSlice.reducer;

// home
export const { appHomeToggleShowSidebar, setTimeZone } = appSlice.actions;
// Здесь (state) => все редюсеры
export const appHomeShowSidebarSelector = (state) => state.app.home;

// stations
// создает фильтр станции
function createStationsFilter(stationFilterName) {
  return createSelector(
    stationsSelect,
    (state) => state.app.stations[stationFilterName],
    ({ data: stations = [] }, stationsFilter) => {
      const upperSearchInput = stationsFilter.searchInput.toUpperCase();

      const defaultChecked = stationsFilter.datasourceTypesFilter.length === 0
        && stationsFilter.showDatasourceMode === 0
        && stationsFilter.showDatasourceReleases === 0
        && stationsFilter.showDatasourceStatus === 0
        && stationsFilter.showDatasourceEnabled === 0
        && stationsFilter.showDatasourceDanger === 0;

      const filteredStations = stations.filter((s) => {
        if (!upperSearchInput) return true;
        if (
          (s.name?.toUpperCase().includes(upperSearchInput)
            || s.idx?.toUpperCase().includes(upperSearchInput))
        ) return true;
        return false;
      }).filter((s) => {
        if (!stationsFilter.fgbu) return true;
        if (s.region.id === stationsFilter.fgbu.id || (s.region.regionFGBU && s.region.regionFGBU.id === stationsFilter.fgbu.id)) return true;
        return false;
      }).filter((s) => {
        if (!stationsFilter.cgms) return true;
        if (s.region.id === stationsFilter.cgms.id) return true;
        return false;
      }).filter((s) => {
        if (!stationsFilter.category) return true;
        if (s.vocStationType.vocStationCat.id === stationsFilter.category.id) return true;
        return false;
      })
        .filter((s) => {
          if (!stationsFilter.type) return true;
          if (s.vocStationType.id === stationsFilter.type.id) return true;
          return false;
        });
      return filteredStations.map((station) => ({
        ...station,
        datasources: station.datasources
          .filter((datasource) => (stationsFilter.datasourceTypesFilter.length > 0 ? stationsFilter.datasourceTypesFilter.includes(`${datasource.datasourceType.id}`) : true))
          .filter((datasource) => stationsFilter.showDatasourceMode === 0 || datasource.vocMode?.id === stationsFilter.showDatasourceMode || (stationsFilter.showDatasourceMode === 3 && datasource?.vocMode === null))
          .filter((datasource) => stationsFilter.showDatasourceReleases === 0 || ((datasource?.isActualRelease === true) && stationsFilter.showDatasourceReleases === 1) || (stationsFilter.showDatasourceReleases === 2 && datasource?.isActualRelease === false) || (stationsFilter.showDatasourceReleases === 3 && datasource?.isActualRelease === null))
          .filter((datasource) => stationsFilter.showDatasourceStatus === 0 || (stationsFilter.showDatasourceStatus === 2 && datasource.dataReceived === false) || (stationsFilter.showDatasourceStatus === 1 && datasource.dataReceived) || (stationsFilter.showDatasourceStatus === 3 && datasource.dataReceived === null))
          .filter((datasource) => stationsFilter.showDatasourceEnabled === 0 || datasource.enabled === (stationsFilter.showDatasourceEnabled === 1) || (datasource.enabled === null && (stationsFilter.showDatasourceEnabled === 1)))
          .filter((datasource) => stationsFilter.showDatasourceDanger === 0 || (stationsFilter.showDatasourceDanger === 2 && datasource.danger === false) || (stationsFilter.showDatasourceDanger === 1 && datasource.danger) || (stationsFilter.showDatasourceDanger === 3 && datasource.danger === null)),
      })).filter((station) => (defaultChecked || station.datasources.length > 0));
    },
  );
}
// используется на странице "карта", "станции"
export const stationsByFilter1Selector = createStationsFilter(STATIONS_FILTER1);
export const stationsFilter1PropsSelector = (state) => state.app.stations[STATIONS_FILTER1];

// используется на странице создания/редактирования отчетов
export const stationsByFilter2Selector = createStationsFilter(STATIONS_FILTER2);
export const stationsFilter2PropsSelector = (state) => state.app.stations[STATIONS_FILTER2];

// используется на странице создания/редактирования станции
export const stationsByFilter3Selector = createStationsFilter(STATIONS_FILTER3);
export const stationsFilter3PropsSelector = (state) => state.app.stations[STATIONS_FILTER3];

// используется в настройках -> датчики
export const stationsByFilter4Selector = createStationsFilter(STATIONS_FILTER4);
export const stationsFilter4PropsSelector = (state) => state.app.stations[STATIONS_FILTER4];

// используется на странице Мониторинг данных
export const stationsByFilter5Selector = createStationsFilter(STATIONS_FILTER5);
export const stationsFilter5PropsSelector = (state) => state.app.stations[STATIONS_FILTER5];
// stations - station - datasource

// reports
function createReportsFilter(reportFilterName) {
  return createSelector(
    reportsSelect,
    (state) => state.app.reports[reportFilterName],
    ({ data: reports = [] }, reportsFilter) => {
      const upperSearchInput = reportsFilter.searchInput.toUpperCase();
      return reports.filter((r) => {
        if (!upperSearchInput) return true;
        if (r.report.reportName?.toUpperCase().includes(upperSearchInput)) return true;
        return false;
      });
    },
  );
}
export const reportsByFilter1Selector = createReportsFilter(REPORTS_FILTER1);
export const reportsFilter1PropsSelector = (state) => state.app.reports[REPORTS_FILTER1];

export const timeZoneSelector = (state) => state.app.timezones;
export const filteredTypedSelector = (state) => state.filtersMonitoring.selectedDatasourceTypesIds;
